import { render, staticRenderFns } from "./userinfo.vue?vue&type=template&id=b9042c48"
import script from "./userinfo.vue?vue&type=script&lang=js"
export * from "./userinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports